export interface CompleteHiringPromptContent {
  title: string;
  text: string;
  confirmText: string;
}

export function getCompleteHiringPromptContent(
  isAcknowledged: boolean,
  t: (key: string) => string,
): CompleteHiringPromptContent {
  if (isAcknowledged) {
    return {
      title: t("order.prompt_form.complete_hiring.title"),
      text: t("order.prompt_form.complete_hiring.text"),
      confirmText: t("order.prompt_form.complete_hiring.confirm"),
    };
  }
  return {
    title: t("order.prompt_form.not_acknowledged.title"),
    text: t("order.prompt_form.not_acknowledged.text"),
    confirmText: t("order.prompt_form.not_acknowledged.confirm"),
  };
}
